import { createAsyncThunk } from '@reduxjs/toolkit';
import { getPickupsRequest, reprintPickupLabelRequest } from './pickupsApi';
import { extractApiError } from '../../utils/errors';

/**
 * Fetches a page of pickups using the filters currently held in the store,
 * mirroring how zones and couriers read their own state.
 *
 * Sentinel values are dropped instead of forwarded: the backend treats a
 * missing param and `'all'` alike, and leaving them out keeps the request URL
 * readable.
 */
export const fetchPickups = createAsyncThunk(
  'pickups/fetchPickups',
  async (_, { getState, rejectWithValue }) => {
    try {
      const { page, rowsPerPage, start_date, end_date, state, seller, search } =
        getState().pickups.filters;

      const params = { page, page_size: rowsPerPage, start_date, end_date };

      if (state !== 'all') params.state = state;
      if (seller !== 'all') params.seller = seller;
      if (search) params.search = search;

      const response = await getPickupsRequest(params);
      return response.data;
    } catch (error) {
      console.error('Error fetching pickups:', error);
      return rejectWithValue(extractApiError(error, 'No se pudieron obtener los pickups'));
    }
  }
);

/**
 * Queues a pickup's label for printing again.
 *
 * The endpoint answers `{"error": ...}` with the actual reason — most often
 * that the admin has no printer configured — so `extractApiError` is what makes
 * the failure legible instead of a generic sentence.
 *
 * @param {number|string} pickupId
 */
export const reprintPickupLabel = createAsyncThunk(
  'pickups/reprintPickupLabel',
  async (pickupId, { rejectWithValue }) => {
    try {
      const response = await reprintPickupLabelRequest(pickupId);
      return response.data;
    } catch (error) {
      console.error('Error reprinting pickup label:', error);
      return rejectWithValue(extractApiError(error, 'No se pudo reimprimir la etiqueta'));
    }
  }
);
